import React, { useEffect, useState } from 'react';
import { Alert } from '@ver-uds/uswds-react';
import { Modal, ButtonGroup, Button } from '@ver-uds/react';
import { useLogout, useRefresh } from '@vis-auth/react';
import IdleTimer from 'react-idle-timer';
import CountDownTimer from './CountDownTimer';

export const SESSION_WARNING_TIMER = 10 * 60 * 1000; // The number of ms of inactivity before state is set to `sessionWarning`.
export const SESSION_TIMEOUT_TIMER = 5 * 60; // The number of seconds AFTER the warning time before being logged out.
export const GATEWAY_SESSION_REFRESH_INTERVAL = 18 * 60 * 1000; // The number of ms to wait between calls to refreshGatewaySession while the user is logged in.

const SessionHandler: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const logout = useLogout();
  const close = () => setIsOpen(false);
  const modalId = 'session-timeout-modal';
  const refreshSession = useRefresh();

  const handleContinueSession = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    refreshSession();
    setIsOpen(false);
  };

  useEffect(() => {
    const refreshSessionInterval = setInterval(() => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      refreshSession();
    }, GATEWAY_SESSION_REFRESH_INTERVAL);

    return () => {
      clearInterval(refreshSessionInterval);
    };
  }, [refreshSession]);

  const Timer = <CountDownTimer initialSeconds={SESSION_TIMEOUT_TIMER} onEnd={(): Promise<void> => logout()} />;
  return (
    <>
      {isOpen ? (
        <Modal id={modalId} header="Session Expiring" open={isOpen} close={close} hasDismissButton={false}>
          <Modal.Content>
            <Alert status="warning">
              <Alert.Heading>Your session will expire in {Timer}</Alert.Heading>
              <Alert.Text>To keep your session active, press Continue. To end your session, press Sign Out.</Alert.Text>
            </Alert>
          </Modal.Content>
          <Modal.Footer>
            <ButtonGroup>
              <Button type="button" variant="secondary" onClick={(): Promise<void> => logout()}>
                Sign Out
              </Button>
              <Button type="button" variant="primary" onClick={handleContinueSession}>
                Continue
              </Button>
            </ButtonGroup>
          </Modal.Footer>
        </Modal>
      ) : (
        <div data-testid="idle-timer">
          <IdleTimer onIdle={() => setIsOpen(true)} timeout={SESSION_WARNING_TIMER} />
        </div>
      )}
    </>
  );
};

// istanbul ignore if: Not used for test environment; Modal.setAppElement should be called in the tests directly.
if (process.env.NODE_ENV !== 'test') {
  Modal.setAppElement('#root');
}

export default SessionHandler;
